import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { useWorkflowTypes } from '../WorkflowsPage/hooks/useWorkflowTypes';
import { formatLocaleDateOrNotSpecified } from '../../utils/validation';
import {
  detailsGridStyles,
  detailLabelStyles,
  detailValueStyles,
  chipStyles,
} from './WorkflowResponseForm.styles';

interface WorkflowDetailsProps {
  accountId: string;
  accountIdLabel?: string;
  caseNumber?: string;
  dismissalDate?: string;
  type: string;
  assignedDate: string;
  assignedToName?: string;
}

export const WorkflowDetails: React.FC<WorkflowDetailsProps> = ({
  accountId,
  accountIdLabel = 'Servicer Account ID',
  caseNumber,
  dismissalDate,
  type,
  assignedDate,
  assignedToName,
}) => {
  const { workflowTypes } = useWorkflowTypes();
  const formattedDismissalDate = formatLocaleDateOrNotSpecified(dismissalDate);

  return (
    <Box sx={detailsGridStyles}>
      <Box>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={detailLabelStyles}
        >
          {accountIdLabel}
        </Typography>
        <Typography variant="body1" sx={detailValueStyles}>
          {accountId}
        </Typography>
      </Box>

      {caseNumber && (
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={detailLabelStyles}
          >
            Case Number
          </Typography>
          <Typography variant="body1" sx={detailValueStyles}>
            {caseNumber}
          </Typography>
        </Box>
      )}

      {type === 'bk_dismissed' && (
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={detailLabelStyles}
          >
            Dismiss Date
          </Typography>
          <Typography variant="body1" sx={detailValueStyles}>
            {formattedDismissalDate}
          </Typography>
        </Box>
      )}

      <Box>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={detailLabelStyles}
        >
          Type
        </Typography>
        <Chip
          label={workflowTypes.find((wt) => wt.value === type)?.label || type}
          size="small"
          sx={chipStyles}
        />
      </Box>

      <Box>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={detailLabelStyles}
        >
          Assigned Date
        </Typography>
        <Typography variant="body1" sx={detailValueStyles}>
          {formatLocaleDateOrNotSpecified(assignedDate)}
        </Typography>
      </Box>

      {assignedToName && (
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={detailLabelStyles}
          >
            Assigned To
          </Typography>
          <Typography variant="body1" sx={detailValueStyles}>
            {assignedToName}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
